module.exports = __webpack_public_path__ + "ee8670f033296c2568f42b61b2f2db2f.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/loader.svg
// module id = YoSI
// module chunks = 0